import { InitializeFromIframeDataIfNeeded } from "./iframe-initializer.js";
import { selectedLanguage, SetLanguage } from "./localization.js";
import { InitializeScene } from "./scene-3d.js";
import { sceneDataReady } from "./scene-data.js";
import { InitializeLandmarkSceneModule } from "./scenes/landmark-edit-scene.js";
import { InitializeSettleSceneModule } from "./scenes/settle-foot-scan-scene.js";
import { InitializeCustomElements } from "./ui/custom-elements.js";
import { InitializeGenericUI } from "./ui/generic-ui.js";
import { InitializeToolsUIData } from "./ui/tools-data.js";

InitializeCustomElements();
InitializeToolsUIData();
InitializeSettleSceneModule();
InitializeLandmarkSceneModule();

async function UpdateSelectedLanguage(force: boolean) {
    await sceneDataReady;
    SetLanguage(selectedLanguage, force);
}

const promises = [
    InitializeScene(),
    InitializeGenericUI(),
    UpdateSelectedLanguage(true),
];

Promise.all(promises).then(async () => {
    await InitializeFromIframeDataIfNeeded();
    const loadingOverlay = document.querySelector("#loading-overlay");
    loadingOverlay?.classList.add("hidden");
});
